import React from "react";

import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";

import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0],
    opacity: [1],
    transition: {
      duration: 0.1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  const zoomElement = document.querySelector(".zoom");
  let zoom = 1;
  const ZOOM_SPEED = 0.01;

  document.addEventListener("wheel", function (e) {
    if (e.deltaY > 0) {
      zoomElement.style.transform = `scale(${(zoom += ZOOM_SPEED)})`;
    } else {
      zoomElement.style.transform = `scale(${(zoom -= ZOOM_SPEED)})`;
    }
  });

  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <div className="zoom">
          <img src={images.road} alt="profile_bg" />
        </div>
      </motion.div>

      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 1.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span></span>
            <div style={{ marginLeft: 20 }}>
              <p className="t-text">Hello, I'm</p>
              <h1 className="head-text">ALLY BATY</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">
              I have been a professional muscian since the age of 18, I have
              been playing in my current band, Sundara Karma, for over a decade.
              and have been fortunate enough to have travelled to some amazing
              places in that time.
            </p>
            <p className="p-text">
              As well as music and photography, I am interest in web
              development, and am keen to gain a deeper understanding of the
              subject.{" "}
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
